/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_SaveInputs */

const en_profile_save = /** @type {(inputs: Profile_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save profile`)
};

const pt_br2_profile_save = /** @type {(inputs: Profile_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar perfil`)
};

/**
* | output |
* | --- |
* | "Save profile" |
*
* @param {Profile_SaveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_save = /** @type {((inputs?: Profile_SaveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_SaveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_save(inputs)
	return pt_br2_profile_save(inputs)
});